
import AOSampler from './texture-samplers/ao_sampler.glsl'
// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

#ifdef USE_AOMAP
	${AOSampler}
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );
	#endif
#endif
`;